import React, { useState } from 'react';
import { User, Calendar, Hash, Tag } from 'lucide-react';
import WidgetCard from './WidgetCard';
import WidgetModal from './WidgetModal';

export default function RecordSummary({ record, fields, fieldData }) {
  const [modalOpen, setModalOpen] = useState(false);
  if (!record) return null;

  const allFields = fields.filter(f =>
    ['TEXT','EMAIL','PHONE','DATE','CURRENCY','NUMBER','DROPDOWN'].includes(f.field_type)
  );
  const previewFields = allFields.slice(0, 3);

  const formatVal = (field, val) => {
    if (!val && val !== 0) return '—';
    if (field.field_type === 'CURRENCY') return '$' + Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 });
    if (field.field_type === 'DATE') return new Date(val).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return String(val);
  };

  const InfoRow = ({ icon, label, value, badge }) => (
    <div className="flex items-center gap-2 text-sm py-1">
      {icon}
      <span className="text-gray-500 text-xs">{label}</span>
      {badge || <span className="text-gray-900 text-xs truncate">{value}</span>}
    </div>
  );

  const content = (fieldList) => (
    <>
      <InfoRow icon={<Hash className="h-3 w-3 text-gray-400" />} label="Ref" value={record.reference_number} />
      {record.stage_name && (
        <InfoRow icon={<Tag className="h-3 w-3 text-gray-400" />} label="Stage"
          badge={<span className="px-2 py-0.5 rounded-full text-[10px] font-medium"
            style={{ backgroundColor: (record.stage_color || '#6b7280') + '20', color: record.stage_color || '#6b7280' }}>
            {record.stage_name}</span>} />
      )}
      <InfoRow icon={<Calendar className="h-3 w-3 text-gray-400" />} label="Created"
        value={new Date(record.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} />
      {record.assigned_to_name && (
        <InfoRow icon={<User className="h-3 w-3 text-gray-400" />} label="Assigned" value={record.assigned_to_name} />
      )}
      {fieldList.map(f => {
        const val = fieldData[f.id];
        if (!val && val !== 0) return null;
        return <InfoRow key={f.id} icon={<div className="w-3" />} label={f.label} value={formatVal(f, val)} />;
      })}
    </>
  );

  return (
    <>
      <WidgetCard title="Summary" icon="📋" onExpand={() => setModalOpen(true)}>
        <div className="px-4 py-2">{content(previewFields)}</div>
      </WidgetCard>
      <WidgetModal open={modalOpen} onClose={() => setModalOpen(false)} title="Record Summary" icon="📋">
        <div className="px-6 py-4 space-y-1">{content(allFields)}</div>
      </WidgetModal>
    </>
  );
}
